/**
 * Main entry point for Kemaris Frontend
 * @description Bootstraps Vue app with router, stores and plugins
 */
import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import authStore from "./stores/authStore";

// Plugins
import BlackDashboard from "./plugins/blackDashboard";

// Styles
import "./assets/sass/black-dashboard.scss";
import "./assets/css/nucleo-icons.css";
import "./assets/sass/pages/_auth.scss";

// Register plugins
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(BlackDashboard);

// Make authStore globally accessible
Vue.prototype.$auth = authStore;

Vue.config.productionTip = false;

// Auth initialisieren, dann App mounten
authStore.init().then(() => {
  new Vue({
    router,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
});
